export enum CoachSkillType {
    GROUP_COACHING = 'group_coaching',
    MOKUMOKU_DESIGN = 'mokumoku_design',
    MOKUMOKU_WRITING = 'mokumoku_writing',
    MOKUMOKU_MARKETING = 'mokumoku_marketing',
}

export enum CoachPositionType {
    GROUP_COACHING = 'group_coaching',
    MOKUMOKU = 'mokumoku',
}

export type CoachSkillCertificationIndexView = {
    type: CoachSkillType;
};
